export default __webpack_public_path__ + "static/media/white close button.b8e26c8f.svg";